/*
 * Rostfri.nu – automatiskt val av giltig variant.
 * När kunden byter t.ex. gängstorlek och den valda längden inte finns i den nya
 * gängstorleken väljs automatiskt en längd som finns (i första hand en som är i lager).
 * Patchar temats VariantSelects/VariantRadios (scripts.js) utan att ändra själva filen.
 */
(function () {
  if (window.__rostfriVariantAutoselect) return;
  window.__rostfriVariantAutoselect = true;

  const cache = {};

  function loadVariants(url) {
    if (!url) return Promise.resolve(null);
    const clean = url.split("?")[0];
    if (!cache[clean]) {
      cache[clean] = { data: null };
      cache[clean].promise = fetch(clean + ".js")
        .then((response) => (response.ok ? response.json() : null))
        .then((product) => {
          cache[clean].data = product && Array.isArray(product.variants) ? product.variants : null;
          return cache[clean].data;
        })
        .catch(() => null);
    }
    return cache[clean].promise;
  }

  function getVariants(element) {
    if (element.variants && element.variants.length) return element.variants;
    const entry = cache[(element.dataset.url || "").split("?")[0]];
    return entry && entry.data ? entry.data : null;
  }

  function prefetchAll() {
    document.querySelectorAll("variant-selects, variant-radios").forEach((element) => {
      loadVariants(element.dataset.url);
    });
  }

  function findBestVariant(element, currentVariant, inputClicked) {
    const variants = getVariants(element);
    if (!variants) return currentVariant;
    // Kombinationen finns: behåll den (även om den är slut i lager, om temat inte döljer slutsålda).
    if (currentVariant && (currentVariant.available || !element.hideOutOfStock)) return currentVariant;

    const container = inputClicked && inputClicked.closest("fieldset, select");
    const position = container ? parseInt(container.dataset.optionPosition, 10) : 0;
    if (!position) return currentVariant;

    const selected = Array.from(
      element.querySelectorAll("fieldset input:checked, select option:checked"),
    ).map((el) => el.value);

    const prefix = selected.slice(0, position).join("\u0000");
    const candidates = variants.filter(
      (variant) => variant.options.slice(0, position).join("\u0000") === prefix,
    );
    if (!candidates.length) return currentVariant;

    // Poäng: behåll så många efterföljande val som möjligt (tidigare alternativ väger tyngst), sedan lagerstatus.
    const score = (variant) => {
      let s = 0;
      const n = variant.options.length;
      for (let i = position; i < n; i++) {
        if (variant.options[i] === selected[i]) s += Math.pow(2, n - i);
      }
      return s * 2 + (variant.available ? 1 : 0);
    };

    let best = candidates[0];
    let bestScore = score(best);
    for (const variant of candidates) {
      const s = score(variant);
      if (s > bestScore) {
        best = variant;
        bestScore = s;
      }
    }

    if (currentVariant && !best.available) return currentVariant;
    return best;
  }

  function patch(ctor) {
    if (!ctor || ctor.prototype.__rostfriPatched) return;
    const proto = ctor.prototype;
    const original = proto.maybeGetFirstAvailableVariant;
    proto.maybeGetFirstAvailableVariant = function (currentVariant, inputClicked) {
      try {
        const result = findBestVariant(this, currentVariant, inputClicked);
        if (result !== currentVariant) return result;
      } catch (e) {
        /* fall tillbaka till temats logik */
      }
      return original ? original.call(this, currentVariant, inputClicked) : currentVariant;
    };
    proto.__rostfriPatched = true;
  }

  customElements.whenDefined("variant-selects").then(() => {
    patch(customElements.get("variant-selects"));
    prefetchAll();
  });
  customElements.whenDefined("variant-radios").then(() => {
    patch(customElements.get("variant-radios"));
    prefetchAll();
  });

  // Snabbvy/omrenderade sektioner: förhämta när kunden börjar interagera.
  document.addEventListener(
    "pointerdown",
    (event) => {
      const element = event.target.closest && event.target.closest("variant-selects, variant-radios");
      if (element) loadVariants(element.dataset.url);
    },
    true,
  );
  document.addEventListener(
    "focusin",
    (event) => {
      const element = event.target.closest && event.target.closest("variant-selects, variant-radios");
      if (element) loadVariants(element.dataset.url);
    },
    true,
  );
})();
